// Where people go on each sofa and bed (sofas and beds, 2026-10-29). A spot (u, v) is where the pose's anchor lands,
// as fractions of the piece's drawn box, unflipped: sitting pins the middle of the feet's bottom edge, lying the middle
// of the figure (scripts/anim/pose/layout.py ANCHOR). Sofas seat two, beds one; all sofas share one sitting pose and
// all beds one lying pose, so the designs were painted to the same seat height / bed view (picks.md).
// Fitted per painting by compositing the pose on it (scripts/anim/pose/cli.py).
const sofa = (u0 = 0.32, u1 = 0.68, v = 0.9) => ({ pose: 'sit', spots: [{ u: u0, v }, { u: u1, v }] });
const bed = (u = 0.51, v = 0.47) => ({ pose: 'lie', spots: [{ u, v }] });

export const FURNITURE_SPOTS = {
  kanapa: sofa(), kanapa_2: sofa(), kanapa_3: sofa(), kanapa_4: sofa(), kanapa_5: sofa(), kanapa_6: sofa(), kanapa_7: sofa(),
  lozko: bed(), lozko_2: bed(), lozko_3: bed(), lozko_4: bed(), lozko_5: bed(),
  // the castle and the starry bed turn their sheet down lower: a little further down the bed it covers the shoulders
  lozko_6: bed(0.51, 0.5), lozko_7: bed(0.51, 0.5),
};

// Display size (longest side, px) — the backend catalog's FurnitureSpec.size, which its floor rule uses.
export const SEAT_SIZE = Object.fromEntries(Object.entries(FURNITURE_SPOTS).map(([id, s]) => [id, s.pose === 'sit' ? 360 : 300]));

export const isSeatFurniture = (p) => p?.type === 'furniture' && !!FURNITURE_SPOTS[p.item];
